import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faPersonDigging} from "@fortawesome/free-solid-svg-icons"
import { Container, Card } from "react-bootstrap";
import { ContextNavbar, ViewProps } from "../components/ContextNavbar";
import { League } from "../components/LeagueList";

import { LeagueData } from "../types/leagueData";
import { MOTM } from "../components/motm";

interface IHomeProps {
  leagueState?: LeagueData
}

const Views: ViewProps[] = [
  {
    nav: "#standings",
    title: "Standings",
    comp: League,
  },
  {
    nav: "#motm",
    title: "Manager of the Month",
    comp: MOTM,
  },
  {
    nav: "#captain",
    title: "Captain",
    comp: TODO,
  },
  {
    nav: "#bench",
    title: "Bench Warmers",
    comp: TODO,
  },
  {
    nav: "#transfers",
    title: "Transfers",
    comp: TODO,
  }
]

function TODO(props: {data: any}) {
  return <Container>
      <h5>
        <FontAwesomeIcon icon={faPersonDigging} size="xl"/>
        Work in progress...
      </h5>
    </Container>
}

export function Home(props: IHomeProps) {
  const [currentView, changeView] = useState<ViewProps>(Views[0]);
  // Handle page load and the searchParams being set
  // Trigger when we connect for the first time
  if (! props.leagueState) {
    return <></>
  }

  return <Container>
    <h2>{props.leagueState.name}</h2>
    <Card>
      <Card.Header>
        <ContextNavbar
          views={Views}
          selectedView={currentView}
          setView={changeView}
        />
      </Card.Header>
      <Card.Body>
        <currentView.comp data={props.leagueState}/>
      </Card.Body>
    </Card>
  </Container>
}
